import { IEmailPreferenceGroup } from '@faire/web-api--source/com/faire/email/preferences/IEmailPreferenceGroup';
import { IEmailPreferencesEmailAddress } from '@faire/web-api--source/com/faire/email/preferences/IEmailPreferencesEmailAddress';
import { IUnsubscribedMarketingTypeGroup } from '@faire/web-api--source/faire/emailsender/requests/IUnsubscribedMarketingTypeGroup';

export namespace IUpdateEmailPreferencesRequest {
  /**
   * Return an instance of IUpdateEmailPreferencesRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IUpdateEmailPreferencesRequest>
  ): IUpdateEmailPreferencesRequest =>
    ({
      email_preference_groups: [],
      unsubscribed_marketing_type_groups: [],
      ...(partial ?? {}),
    }) as IUpdateEmailPreferencesRequest;
}

export interface IUpdateEmailPreferencesRequest {
  /**
   * outgoing email that was used to initiate this request
   */
  outgoing_email_token: string | undefined;
  /**
   * causes all possible
   */
  unsubscribe_from_all: boolean | undefined;
  /**
   * email preferences to update
   */
  email_preference_groups: Array<IEmailPreferenceGroup>;
  /**
   * Address to adjust the preferences of
   */
  requested_email_address: IEmailPreferencesEmailAddress | undefined;
  /**
   * Unsubscribed from marketing types
   */
  unsubscribed_marketing_type_groups: Array<IUnsubscribedMarketingTypeGroup>;
}
